// 블로그 상태 / 카테고리 관련 상수와 라벨 매핑

export const BLOG_STATUS_OPTIONS = [
  { value: "all", label: "전체 상태" },
  { value: "draft", label: "초안" },
  { value: "published", label: "발행" },
];

export const BLOG_CATEGORY_ALL_OPTION = { value: "all", label: "전체 카테고리" };

// 글이 노출되는 사이트 구역. blog_category.section 과 같은 값.
export const BLOG_SECTION_OPTIONS = [
  { value: "all", label: "전체 구분" },
  { value: "blog", label: "블로그" },
  { value: "support", label: "정부지원사업" },
];

export const BLOG_SECTION_LABEL = {
  blog: "블로그",
  support: "정부지원사업",
};

export const BLOG_STATUS_LABEL = {
  draft: "초안",
  published: "발행",
};

export const BLOG_STATUS_BADGE = {
  draft: "neutral",
  published: "success",
};

export const BLOG_DEFAULT_AUTHOR = {
  author_name: "마크픽",
  author_role_label: "마크픽 공식 블로그",
  author_bio: "",
};

export const BLOG_MAX_LENGTH = {
  title: 300,
  excerpt: 500,
};

// 제한된 slug 정규식 (한글/영문/숫자/하이픈)
export const BLOG_SLUG_REGEX = /^[가-힣a-zA-Z0-9-]+$/;

// 이미지 업로드 허용 확장자 (백엔드 제약과 일치)
export const BLOG_IMAGE_EXTENSIONS = ["jpg", "jpeg", "png", "webp", "gif"];

// 에러 상황 → 토스트 메시지
export const BLOG_ERROR_MESSAGE = {
  slugConflict: "이미 사용 중인 slug 입니다. 다른 값으로 입력해 주세요.",
  notFound: "삭제된 글입니다.",
  invalidImage: "jpg, jpeg, png, webp, gif 파일만 업로드할 수 있습니다.",
  uploadFailed: "이미지 업로드 중 오류가 발생했습니다.",
  serverError: "서버 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.",
  categoryRequired: "카테고리를 선택해 주세요.",
  titleRequired: "제목을 입력해 주세요.",
  contentRequired: "본문을 입력해 주세요.",
  slugInvalid: "slug는 한글, 영문, 숫자, 하이픈(-)만 사용할 수 있습니다.",
  titleTooLong: `제목은 ${300}자 이하로 입력해 주세요.`,
  excerptTooLong: `요약은 ${500}자 이하로 입력해 주세요.`,
};

// 태그 문자열(콤마구분) ↔ 배열 변환
export const parseTags = (tagString) => {
  if (!tagString) return [];
  return tagString
    .split(",")
    .map((t) => t.trim())
    .filter(Boolean);
};

export const stringifyTags = (tagArray) => {
  if (!Array.isArray(tagArray)) return "";
  return tagArray.join(", ");
};

// FastAPI error detail 정규화
//  - 문자열: 그대로 반환
//  - 배열 (422 ValidationError): 첫 msg 또는 콤마 연결
//  - 기타: null
export const normalizeErrorDetail = (detail) => {
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    const msgs = detail
      .map((d) => (typeof d === "string" ? d : d?.msg))
      .filter(Boolean);
    return msgs.length ? msgs.join(", ") : null;
  }
  return null;
};

// Quill 에디터가 비어 있는지 검사 (빈 <p><br></p> 포함)
export const isQuillEmpty = (html) => {
  if (!html) return true;
  const stripped = html
    .replace(/<p>\s*<br\s*\/?>\s*<\/p>/g, "")
    .replace(/<p>\s*<\/p>/g, "")
    .replace(/<br\s*\/?>/g, "")
    .replace(/&nbsp;/g, "")
    .replace(/\s/g, "");
  return stripped === "";
};

// 날짜 포맷: "2026-04-20T09:00:00" → "2026-04-20"
export const formatDate = (iso) => {
  if (!iso) return "-";
  return iso.split("T")[0];
};
